<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{new Date().getFullYear()}} © XMART NET.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by <a href="https://crosstechno.com">CrossTechno</a>
                </div>
            </div>
        </div>
    </div>
</footer>
</template>
